/* eslint-disable no-confusing-arrow */
const { recommendRandomSort, formatImage, formatUrl } = require('@ifeng-fe/public_method');

module.exports = {
    jsonParse: data => {
        return JSON.parse(data);
    },
    handleSubjectData: data => {
        return data.map(
            (item, index) =>
                index === 0
                    ? {
                          img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 270, 105) : '',
                          url: formatUrl(item.url),
                          title: item.title,
                      }
                    : {
                          url: formatUrl(item.url),
                          title: item.title,
                      },
        );
    },
};
